module.exports = __webpack_public_path__ + "img/prop_exploding_barrel.7c6a59d6.svg";